var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#453DB7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7322 5.74023C13.6002 5.74023 13.5282 5.74023 13.3962 5.74023L8.77617 10.3602L6.61617 8.20023C6.48417 8.20023 6.41217 8.20023 6.28017 8.20023L4.57617 9.89223C4.57617 10.0242 4.57617 10.0962 4.57617 10.2282L8.60817 14.2602C8.74017 14.2602 8.81217 14.2602 8.94417 14.2602L15.4242 7.78023C15.4242 7.64823 15.4242 7.57623 15.4242 7.44423L13.7322 5.74023Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxSelected);
export default __webpack_public_path__ + "static/media/checkbox-selected.163ae885dbef45141fdfcbbb4b5f66ff.svg";
export { ForwardRef as ReactComponent };